import { useQuery } from '@tanstack/react-query';

import { getTimeOffTypes } from '../../api/time-offs.api';
import { TimeOffTypeCode } from '../../types/time-off';

export const TIME_OFF_TYPES_QUERY_KEY = ['time-off-types'] as const;
const TIME_OFF_TYPES_STALE_TIME = 1 * 60 * 60 * 1000; // 1 hour

export const useTimeOffTypes = () => {
  return useQuery({
    queryKey: TIME_OFF_TYPES_QUERY_KEY,
    queryFn: getTimeOffTypes,
    staleTime: TIME_OFF_TYPES_STALE_TIME,
    // Public Holiday is not configurable in this table yet — exclude it here (UI
    // concern) rather than in the API layer. TODO: drop once Opsium supports it.
    select: types => types.filter(type => type.code !== TimeOffTypeCode.PUBLIC_HOLIDAY),
  });
};
